import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { Router, Route, IndexRoute, useRouterHistory } from 'react-router';
import { createHistory } from 'history';
import Search from '../Search';
import SalesCatalogue from './SalesCatalogue';
import SalesCatalogues from './SalesCatalogues';
import Shortlist from './Shortlist';
import StatisticsCatalogues from './StatisticsCatalogues';
import Statistics from './Statistics';
import StatisticsSales from './StatisticsSales';
import StatisticsSires from './StatisticsSires';
import StatisticsBuyers from './StatisticsBuyers';
import StatisticsVendors from './StatisticsVendors';
import Catalogue from './Catalogue/';
import Sires from './Sires';
import PreviouslySoldLots from './PreviouslySoldLots';
import Vendors from './Vendors';
const browserHistory = useRouterHistory(createHistory)({ basename: '/bloodstock/sales' });

const Root = (props) => {
    const { store } = props;
    const history = syncHistoryWithStore(browserHistory, store);
    return (
        <Provider store={store}>
            <Router history={history}>
                <Route path="/" component={SalesCatalogues} />
                <Route path="/catalogues" component={SalesCatalogues} />
                <Route path="/catalogues/:id/:date" component={SalesCatalogue}>
                    <IndexRoute component={Catalogue} />
                    <Route
                        path="/catalogues/:id/:date/previously-offered-lots"
                        component={PreviouslySoldLots}
                    />
                    <Route path="/catalogues/:id/:date/sires" component={Sires} />
                    <Route path="/catalogues/:id/:date/vendors" component={Vendors} />
                </Route>
                <Route path="/search(/:tab)" component={Search} />
                <Route path="/my-shortlist" component={Shortlist} />
                <Route path="/statistics" component={StatisticsCatalogues} />
                <Route path="/statistics/:id/:startDate" component={Statistics}>
                    <IndexRoute component={StatisticsSales} />
                    <Route path="/statistics/:id/:startDate/sires" component={StatisticsSires} />
                    <Route
                        path="/statistics/:id/:startDate/buyers"
                        component={StatisticsBuyers}
                    />
                    <Route
                        path="/statistics/:id/:startDate/vendors"
                        component={StatisticsVendors}
                    />
                </Route>
            </Router>
        </Provider>
    );
};

Root.propTypes = {
    store: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./src/js/containers/Root.js